//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.js";
import "../no/Builder.js";
let d=[[],[[[],"ImportDefaultTemplate",{},0,0],[["filePath"],"ImportFromOtherMachine",{},1,0],[["templateType"],"SetTemplateType",{},1,1],[[],"GetTemplateType",{R_:{templateType:''}},0,1],[["templateLocation"],"SetTemplateLocation",{},1,1],[[],"GetTemplateLocation",{R_:{templateLocation:''}},0,1],[["filePath"],"SetTemplateFilePath",{},1,1],[[],"GetTemplateFilePath",{R_:{filePath:''}},0,1]],[]];
SPLM.SIM.SmkTransitionPathEditorBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.SmkTransitionPathEditorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SIM.SmkTransitionPathEditorBuilder.TemplateType = Object.freeze({
    "Before" : "Before", "Between" : "Between", "After" : "After", "BetweenNCM" : "BetweenNCM"});

SPLM.SIM.SmkTransitionPathEditorBuilder.TemplateLocation = Object.freeze({
    "FromKinematic" : "FromKinematic", "FromOtherPart" : "FromOtherPart"});

export default SPLM;